// Ключ, по которому RequestStore.vue решает, нужно ли перезапросить список (см. вотчер на
// querySignature). method и id — отдельные термы, а не через $route/endpoint напрямую:
// endpoint строится из $route.params.method и обновляется РАНЬШЕ, чем filters.state успевает
// подхватить новый method внутри filters.init() (вотчер на querySignature регистрируется
// раньше вотчера на $route.params.method, поэтому успевает сработать первым, ещё до init()).
//
// Из-за этого при переходе между двумя вкладками с ОДИНАКОВЫМИ дефолтными фильтрами
// (например store → inbox — обе дают {"search":"","sort":{"type":0,"reverse":true},
// "filter":{}}) промежуточная сигнатура (уже новый route.method, но ещё старый filters.state)
// совпадала с финальной побайтово — Vue не видел изменения при повторном вычислении и вотчер
// не срабатывал вообще: список не перезапрашивался, оставался пустым/старым до F5. Переход на
// вкладку с непустыми фильтрами (например outbox → store) работал только потому, что
// промежуточное и финальное значения там различались случайно, не по конструкции.
//
// method здесь обязан браться из filters.state.method, а не из $route: это единственный
// источник, который меняется синхронно и одномоментно со всем остальным filters.state внутри
// filters.init() — до init() он не меняется, после — меняется один раз и согласованно,
// промежуточного значения возникнуть не может в принципе.
//
// id — наоборот, берётся из $route.params.id напрямую: смена id НЕ запускает filters.init()
// (вотчер стоит только на .method) и никак не рассогласовывает filters.state, так что гонку
// это не возвращает. id нужен для method === 'view' — RequestStore.vue сам фетчит список из
// одного элемента через /requests/view/{id} (см. get endpoint()), и переход между разными id
// при неизменном method обязан перезапрашивать список.
export function buildQuerySignature({ method, id, query }) {
    if (!query) return '';

    return `${method}|${id}|${JSON.stringify(query)}`;
}
